import { render } from "./BrandMarketPerformanceSummary.vue?vue&type=template&id=10eec88f&scoped=true"
import script from "./BrandMarketPerformanceSummary.vue?vue&type=script&lang=js"
export * from "./BrandMarketPerformanceSummary.vue?vue&type=script&lang=js"

import "./BrandMarketPerformanceSummary.vue?vue&type=style&index=0&id=10eec88f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10eec88f"]])

export default __exports__